/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Error_Name_RequiredInputs */

const en_manual_qc_error_name_required = /** @type {(inputs: Manual_Qc_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a name for the issue`)
};

const fr_manual_qc_error_name_required = /** @type {(inputs: Manual_Qc_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez saisir un nom pour l'incident`)
};

const de_manual_qc_error_name_required = /** @type {(inputs: Manual_Qc_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie einen Namen für das Problem ein.`)
};

const it_manual_qc_error_name_required = /** @type {(inputs: Manual_Qc_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome per il problema`)
};

const ru_manual_qc_error_name_required = /** @type {(inputs: Manual_Qc_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, укажите название проблемы.`)
};

const es_manual_qc_error_name_required = /** @type {(inputs: Manual_Qc_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese un nombre para el problema`)
};

const zh_cn2_manual_qc_error_name_required = /** @type {(inputs: Manual_Qc_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入问题的名称`)
};

const ja_manual_qc_error_name_required = /** @type {(inputs: Manual_Qc_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題の名前を入力してください`)
};

const hi_manual_qc_error_name_required = /** @type {(inputs: Manual_Qc_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया समस्या का नाम दर्ज करें`)
};

const pt_pt2_manual_qc_error_name_required = /** @type {(inputs: Manual_Qc_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira um nome para o problema.`)
};

/**
* | output |
* | --- |
* | "Please enter a name for the issue" |
*
* @param {Manual_Qc_Error_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_error_name_required = /** @type {((inputs?: Manual_Qc_Error_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Error_Name_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_error_name_required(inputs)
	if (locale === "de") return de_manual_qc_error_name_required(inputs)
	if (locale === "it") return it_manual_qc_error_name_required(inputs)
	if (locale === "ru") return ru_manual_qc_error_name_required(inputs)
	if (locale === "es") return es_manual_qc_error_name_required(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_error_name_required(inputs)
	if (locale === "ja") return ja_manual_qc_error_name_required(inputs)
	if (locale === "hi") return hi_manual_qc_error_name_required(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_error_name_required(inputs)
	return en_manual_qc_error_name_required(inputs)
});